"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectFaces = void 0;
var neverthrow_1 = require("neverthrow");
var face_library_1 = require("../../util/face_library");
var db_1 = require("../../util/db");
var OVERLAPPING_FACE_COLLECTIONS = {
    'chicagocash': ['chicagorcp', 'cookcounty'],
    'lacbusinesses': ['lacworkers'],
    'lacworkers': ['lacbusinesses']
};
exports.DetectFaces = {
    getSlugs: function (params) {
        return (0, neverthrow_1.ok)({ 'slugs': [
                '_face',
                '_duplicates',
                '_related',
                '_unindexed_reason',
                '_conversion'
            ] });
    },
    compute: function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var key, value, uid, ids, updates, photoUrl_1, config, collectionId_1, id0lower, prev_face, hashFaceResponse_1, indexedFaceId_1, otherCollectionsToCheck, allMatches_1, promises, results, matches_1, relatedMatches, _loop_1, _b, _c, _d, _i, match, metadata, related;
            var _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        console.debug("Detecting faces for field ".concat(params.targetField));
                        if (!params.targetField.endsWith('_face')) {
                            // only compute once.
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        if (!params.conn) {
                            console.log("Cannot detect faces without a connection.");
                            // This is for optimistic compute, so don't return an error.
                            // Just don't compute this field. (It will be computed when called via the API)
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        key = params.targetField.replace(/\_face$/, '').replace(/\_duplicates$/, '').replace(/\_related$/, '').replace(/\_unindexed\_reason$/, '');
                        value = params.newInfoKeys[key];
                        uid = params.newInfoKeys['uid'];
                        if (!uid) {
                            console.log("Cannot detect faces without a uid.");
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        ids = (',' + (value || '')).split(",https:").filter(function (url) { return url && url.startsWith('//'); }).map(function (url) { return "https:".concat(url); });
                        updates = {};
                        console.log("Face IDs: ", ids);
                        if (!(ids.length > 0 && ids[0] !== '')) return [3 /*break*/, 10];
                        photoUrl_1 = ids[0];
                        return [4 /*yield*/, params.configPromise];
                    case 1:
                        config = (_f.sent()) || {};
                        collectionId_1 = JSON.parse(config['fraud'] || '{}').useSpecificFaceCollection || params.deploymentKey;
                        id0lower = photoUrl_1.toLowerCase();
                        if (((_a = params.computeOptions) === null || _a === void 0 ? void 0 : _a.skipHeics) && (id0lower.endsWith('heic') || id0lower.endsWith('pdf'))) {
                            console.log("Skipping HEIC/PDF image for face detection: ", photoUrl_1);
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        prev_face = params.newInfoKeys[key + '_face'];
                        if (!(prev_face && prev_face.indexOf('https') === -1)) return [3 /*break*/, 3];
                        // delete the face
                        return [4 /*yield*/, (0, face_library_1.deleteFace)(prev_face, collectionId_1, params.deploymentKey)];
                    case 2:
                        // delete the face
                        _f.sent();
                        _f.label = 3;
                    case 3: return [4 /*yield*/, (0, face_library_1.hashFaceAtUrl)({
                            config: config,
                            deploymentKey: params.deploymentKey,
                            url: photoUrl_1,
                            uid: uid,
                            key: key,
                            aidkitCrypto: params.aidkitCrypto
                        })];
                    case 4:
                        hashFaceResponse_1 = _f.sent();
                        if (hashFaceResponse_1.isErr()) {
                            console.debug("Error hashing face at URL: ".concat(photoUrl_1, ". Error:"), hashFaceResponse_1.error);
                            return [2 /*return*/, (0, neverthrow_1.ok)((_e = {},
                                    _e[key + '_face'] = '',
                                    _e[key + "_unindexed_reason"] = hashFaceResponse_1.error,
                                    _e[key + "_conversion"] = '',
                                    _e))];
                        }
                        // If there was a conversion, save that to _conversion
                        if (hashFaceResponse_1.value.conversion) {
                            updates[key + '_conversion'] = hashFaceResponse_1.value.conversion;
                        }
                        console.debug("Hashed face at URL successfully: ", hashFaceResponse_1.value);
                        if (hashFaceResponse_1.value.unindexedReasons && hashFaceResponse_1.value.unindexedReasons.length > 0) {
                            updates[key + '_unindexed_reason'] = hashFaceResponse_1.value.unindexedReasons.map(function (r) { return r.replace(/[0-9]/g, '*'); }).join(',');
                            updates[key + '_face'] = '';
                            return [2 /*return*/, (0, neverthrow_1.ok)(updates)];
                        }
                        indexedFaceId_1 = hashFaceResponse_1.value.indexedFaceId;
                        updates[key + '_face'] = indexedFaceId_1;
                        updates[key + '_unindexed_reason'] = '';
                        otherCollectionsToCheck = OVERLAPPING_FACE_COLLECTIONS[collectionId_1];
                        console.log("Searching face in collections: ", indexedFaceId_1, collectionId_1, otherCollectionsToCheck);
                        allMatches_1 = {};
                        promises = __spreadArray([collectionId_1], __read((otherCollectionsToCheck || [])), false).map(function (c) { return __awaiter(_this, void 0, void 0, function () {
                            var matchesResponse;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(c !== collectionId_1)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, face_library_1.searchImageInCollection)(c, hashFaceResponse_1.value.conversion || photoUrl_1)];
                                    case 1:
                                        // if searching in a satellite collection, the face is not indexed in the satellite collection 
                                        // so we need to search by image instead of face
                                        matchesResponse = _a.sent();
                                        return [3 /*break*/, 4];
                                    case 2: return [4 /*yield*/, (0, face_library_1.searchFaceInCollection)(indexedFaceId_1, c)];
                                    case 3:
                                        matchesResponse = _a.sent();
                                        _a.label = 4;
                                    case 4:
                                        if (matchesResponse.isOk()) {
                                            return [2 /*return*/, matchesResponse.value];
                                        }
                                        return [2 /*return*/, null];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 5:
                        results = _f.sent();
                        results.forEach(function (result) {
                            if (result) {
                                Object.assign(allMatches_1, result);
                            }
                        });
                        matches_1 = [];
                        relatedMatches = [];
                        _loop_1 = function (match) {
                            var _g, matchUid, matchKey, matchDeployment;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        _g = __read(match.split(':'), 3), matchUid = _g[0], matchKey = _g[1], matchDeployment = _g[2];
                                        if (!(matchUid !== uid)) return [3 /*break*/, 3];
                                        if (!(params.deploymentKey === 'chicagocash' && ['cookcounty', 'chicagorcp'].includes(matchDeployment))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, db_1.withDB)(matchDeployment, function checkEnrolledGD(conn) {
                                                return __awaiter(this, void 0, void 0, function () {
                                                    var criteriaCheck, err_1;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                _a.trys.push([0, 2, , 3]);
                                                                return [4 /*yield*/, conn.query("\n                  SELECT applicant\n                  FROM applicantinfo\n                  WHERE applicant = $1 AND key = 'enrolled_gd' AND value = 'yes' AND latest = true", [matchUid])];
                                                            case 1:
                                                                criteriaCheck = _a.sent();
                                                                if (criteriaCheck.rowCount === 1) {
                                                                    console.log("CEF app: ".concat(uid, " face matches app: ").concat(matchUid, " enrolled in program: ").concat(matchDeployment, " with enrolled_gd = 'yes'"));
                                                                    matches_1.push(match);
                                                                }
                                                                return [3 /*break*/, 3];
                                                            case 2:
                                                                err_1 = _a.sent();
                                                                console.error(err_1, "CEF app: ".concat(uid, " face matches app: ").concat(matchUid, " enrolled in program: ").concat(matchDeployment, " with enrolled_gd = 'yes'"));
                                                                return [3 /*break*/, 3];
                                                            case 3: return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            })];
                                    case 1:
                                        _h.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        matches_1.push(match);
                                        _h.label = 3;
                                    case 3:
                                        if (matchUid === uid && matchKey && matchKey !== key) {
                                            relatedMatches.push(match);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _b = allMatches_1;
                        _c = [];
                        for (_d in _b)
                            _c.push(_d);
                        _i = 0;
                        _f.label = 6;
                    case 6:
                        if (!(_i < _c.length)) return [3 /*break*/, 9];
                        _d = _c[_i];
                        if (!(_d in _b)) return [3 /*break*/, 8];
                        match = _d;
                        return [5 /*yield**/, _loop_1(match)];
                    case 7:
                        _f.sent();
                        _f.label = 8;
                    case 8:
                        _i++;
                        return [3 /*break*/, 6];
                    case 9:
                        if (matches_1.length > 0) {
                            metadata = {
                                // 'related' is of the form collectionId:uid:targetField:deployment
                                "related": matches_1.map(function (match) { return collectionId_1 + ":" + match; }),
                                "flag": "duplicate_face"
                            };
                            updates[key + '_duplicates'] = JSON.stringify(metadata);
                        }
                        else {
                            updates[key + '_duplicates'] = '';
                        }
                        if (relatedMatches.length > 0) {
                            related = relatedMatches.map(function (match) { return match.split(':')[1] + ":" + allMatches_1[match]['FaceId']; }).join(',');
                            updates[key + '_related'] = related;
                        }
                        else {
                            updates[key + '_related'] = '';
                        }
                        return [3 /*break*/, 11];
                    case 10:
                        updates[key + '_face'] = '';
                        updates[key + '_duplicates'] = '';
                        updates[key + '_related'] = '';
                        updates[key + '_unindexed_reason'] = '';
                        updates[key + '_conversion'] = '';
                        _f.label = 11;
                    case 11:
                        console.log("Returning updates for detect faces:", updates);
                        return [2 /*return*/, (0, neverthrow_1.ok)(updates)];
                }
            });
        });
    }
};
